import React from 'react';
import Pinpoints from '../components/Pinpoints';

export default function HouseCleaning() {
  return (
    <main className='am-container house-cleaning-page'>
      <section className='hc-hero'>
        <div className='hc-content'>
          <h1 className='hc-title'>A Cleaner, Healthier Home – Without the Effort</h1>

          <p className='hc-lead'>
            Keeping your home spotless takes time and energy. At AM Facilities, we take care of the hard work for you,
            ensuring a fresh, hygienic, and inviting space.
          </p>

          <p className='hc-lead'>
            Whether you need a deep clean, regular maintenance, or move-in/move-out services, our professional team is
            here to help.
          </p>

          <h2 className='hc-sub'>Our Services Include:</h2>

          <Pinpoints
            className='hc-list'
            iconClass='hc-badge'
            itemTag='div'
            items={[
              <>
                <strong>Deep Cleaning:</strong>A thorough top-to-bottom clean, perfect for seasonal refreshes.
              </>,
              <>
                <strong>Recurring Cleaning:</strong>Weekly, bi-weekly, or monthly plans to maintain a tidy home.
              </>,
              <>
                <strong>Move-In/Move-Out Cleaning:</strong>A stress-free way to ensure your home is ready for its next
                chapter.
              </>,
              <>
                <strong>Kitchen & Bathroom Sanitization:</strong>Eliminating germs where they matter most.
              </>,
              <>
                <strong>Dusting & Vacuuming:</strong>Removing allergens and keeping your home fresh.
              </>,
            ]}
          />

          <p className='hc-cta-lead'>
            Enjoy a cleaner, healthier home — without the hassle.
            <br />
            Contact us today for a free quote!
          </p>

          <div className='hc-actions'>
            <a
              className='am-cta am-cta-primary'
              href='https://app.zenmaid.com/book/a-m-facilities'
              target='_blank'
              rel='noreferrer noopener'
            >
              I want my house clean today
            </a>
          </div>

          <div className='hc-back'>
            <a href='/#services' className='hc-back-link'>
              Click here and go back to the main services.
            </a>
          </div>
        </div>

        <aside className='hc-aside'>
          <img src='/assets/house_cleaning_top.avif' alt='House cleaning - stove top' className='hc-image-top' />
          <img src='/assets/house_cleaning_bottom.avif' alt='House cleaning supplies' className='hc-image-bottom' />
        </aside>
      </section>
    </main>
  );
}
